export default function Philosophy() {
  return (
    <section id="philosophy" className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-white via-[#F0FDF4] to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-[#10B981]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 md:w-96 md:h-96 bg-[#10B981]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="inline-block px-4 py-2 bg-[#10B981]/10 text-[#10B981] text-xs sm:text-sm font-semibold rounded-full mb-4 md:mb-6">
            PHILOSOPHY
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-4">
            케어인슈의 철학
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            장기요양시설과 현장 전문인력을 위한 진정한 보험을 만들겠다는<br className="hidden sm:block" />
            확고한 철학으로 20년간 한 길을 걸어왔습니다
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center mb-12 md:mb-16 lg:mb-20">
          {/* Left: Image */}
          <div className="relative group px-4 sm:px-0">
            <div className="absolute inset-0 bg-gradient-to-br from-[#10B981]/20 to-transparent rounded-2xl md:rounded-3xl transform rotate-3 group-hover:rotate-0 transition-transform duration-500"></div>
            <img 
              src="https://public.readdy.ai/ai/img_res/4a3ae8dcbb1975d6d686be3730fd05d4.jpg"
              alt="케어인슈의 철학"
              className="relative rounded-2xl md:rounded-3xl shadow-2xl w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover transform group-hover:scale-[1.02] transition-transform duration-500"
            />
          </div>

          {/* Right: Philosophy Points */}
          <div className="space-y-4 md:space-y-6 px-4 sm:px-0">
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-[#10B981]/10 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-xl md:text-2xl text-[#10B981]"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">시설 중심의 보험 설계</h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    장기요양시설의 실제 운영 환경과 리스크를 깊이 이해하고, 시설 운영자의 입장에서 설계된 맞춤형 보험 상품을 제공합니다.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-[#10B981]/10 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-user-line text-xl md:text-2xl text-[#10B981]"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">전문인 권익 보호</h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    요양보호사, 간호사 등 현장 전문인력의 권익을 적극적으로 보호하며, 부당한 책임 전가를 방지합니다.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-[#10B981]/10 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-xl md:text-2xl text-[#10B981]"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">합리적 보험료 실현</h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    20년간 축적된 자사 경험 데이터를 바탕으로 불필요한 비용을 제거하고, 합리적인 보험료 구조를 실현했습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 px-4 sm:px-0">
          <div className="bg-gradient-to-br from-white to-[#F0FDF4] rounded-2xl md:rounded-3xl p-8 md:p-10 shadow-xl text-center border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
            <div className="text-4xl md:text-5xl font-bold text-[#10B981] mb-2 md:mb-3">20년</div>
            <p className="text-base md:text-lg font-semibold text-gray-900 mb-2">전문 경력</p>
            <p className="text-sm md:text-base text-gray-600">
              장기요양시설 보험 전문
            </p>
          </div>
          <div className="bg-gradient-to-br from-white to-[#F0FDF4] rounded-2xl md:rounded-3xl p-8 md:p-10 shadow-xl text-center border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
            <div className="text-4xl md:text-5xl font-bold text-[#10B981] mb-2 md:mb-3">3,000+</div>
            <p className="text-base md:text-lg font-semibold text-gray-900 mb-2">가입 시설</p>
            <p className="text-sm md:text-base text-gray-600">
              전국 장기요양시설 신뢰
            </p>
          </div>
          <div className="bg-gradient-to-br from-white to-[#F0FDF4] rounded-2xl md:rounded-3xl p-8 md:p-10 shadow-xl text-center border-2 border-[#10B981]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
            <div className="text-4xl md:text-5xl font-bold text-[#10B981] mb-2 md:mb-3">98%</div>
            <p className="text-base md:text-lg font-semibold text-gray-900 mb-2">고객 만족도</p>
            <p className="text-sm md:text-base text-gray-600">
              신속하고 공정한 처리
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
